/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../utils';
// prettier-ignore
const DownloadFilledIcon = createIcon({
    displayName: 'DownloadFilledIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M4 12c0-5.138 2.862-8 8-8 5.137 0 8 2.862 8 8 0 5.137-2.863 8-8 8-5.138 0-8-2.863-8-8Zm11.543.984.007-.008c.073-.088.158-.187.285-.333l-1.003-.878c-.133.153-.22.257-.298.348l-.006.008c-.115.135-.207.243-.408.462a40.675 40.675 0 0 1-1.45 1.505V8h-1.33v6.088c-.494-.486-.91-.92-1.45-1.505-.206-.224-.297-.332-.415-.471l-.297-.347-1.003.878.284.331c.129.152.228.269.453.513a41.94 41.94 0 0 0 2.055 2.097 1.497 1.497 0 0 0 2.076 0 42.29 42.29 0 0 0 2.056-2.097c.22-.239.319-.356.444-.503Z",
            clipRule: "evenodd"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M1 12C1 4.936 4.936 1 12 1s11 3.936 11 11-3.936 11-11 11S1 19.064 1 12Zm15.645 2.227c.332-.36.481-.537.67-.76l.007-.008c.111-.13.238-.28.429-.498l-1.506-1.317c-.2.23-.332.385-.448.521l-.013.016c-.17.2-.309.363-.61.69a60.991 60.991 0 0 1-2.176 2.257V6h-2v9.128c-.74-.73-1.367-1.38-2.176-2.257-.31-.336-.447-.498-.625-.707a39.99 39.99 0 0 0-.446-.52l-1.506 1.317.427.496c.193.228.343.404.68.77a62.965 62.965 0 0 0 3.087 3.145 2.25 2.25 0 0 0 3.118 0 63.425 63.425 0 0 0 3.088-3.145Z",
            clipRule: "evenodd"
        })
    ]
});
DownloadFilledIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'DownloadFilledIcon'
};
export { DownloadFilledIcon };

//# sourceMappingURL=download_filled.js.map